<template>
  <div class="content-box">
    <div class="essay-box">
      <textarea
        v-model="textContent"
        maxlength="2000"
        placeholder="请输入待润色的短文，我能帮你修改语法用词，优化语言表达，提升写作文采"
        class="essay-box-text"
      ></textarea>
      <div class="essay-box-tools">
        <i
          v-show="textContent.length"
          class="iconfont icon-qingkong essay-box-tools_icon"
          @click="textContent = ''"
        ></i>
        <div class="essay-box-tools_text">{{ textContent.length }}/2000</div>
      </div>
    </div>
    <div class="button-group">
      <div class="essay-button cancel-button button-ripple" @click="handleCancel">取消</div>
      <div class="essay-button button-ripple" @click="handleConfirm">确定</div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref, watch } from "vue";
import { modalController } from "@ionic/vue";

const props = defineProps(["result"]);

const textContent = ref('')

watch(
  () => props.result,
  () => {
    if (props.result) {
      if(props.result.length > 2000) {
        textContent.value = props.result.slice(0, 2000);
      }else{
        textContent.value = props.result;
      }
    }
  },
  { immediate: true }
);

function handleCancel(){
  modalController.dismiss()
}

function handleConfirm(){
  modalController.dismiss(textContent.value)
}


</script>

<style scoped lang="less">
.content-box {
  width: 100%;
  height: 100%;
  padding: 17px;
  box-sizing: border-box;

  .essay-box {
    width: 100%;
    height: calc(100% - 6.2rem);
    background: linear-gradient(90deg, #00acff 0%, #3effb9 100%);
    border-radius: 0.8rem;
    position: relative;

    &-text {
      background: #ffffff;
      width: calc(100% - 0.4rem);
      height: calc(100% - 0.4rem);
      margin: 0.2rem;
      border-radius: 0.7rem;
      border: none;
      outline: none;
      padding: 0.8rem;
      font-size: 1rem;
      line-height: 1.5rem;
      font-weight: 400;
      color: #262626;
      resize: none;

      &::placeholder {
        color: #868f9e;
      }

      &:focus-within {
        outline: none;
      }
    }

    &-tools {
      position: absolute;
      bottom: 1rem;
      right: 1rem;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 0.8rem;
      background-color: white;
      &_icon {
        font-size: 1rem;
        color: #262626;
        margin-right: 0.5rem;
      }

      &_text {
        color: #868f9e;
      }
    }
  }
  .button-group{
    margin-top: 2.5rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .essay-button {
      width:48%;
      height: 3rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background: linear-gradient(90deg, #2bcac0 0%, #2bca9c 100%);
      border-radius: 2rem;
      color: #ffffff;
      font-size: 1.2rem;
    }
    .cancel-button{
      background: #F2F3F6!important;
      color: #1E2023;
    }
  }
}
</style>
